export default "__VITE_ASSET__p7BPaRCw__"